import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  static values = {
    resultsCount: Number,
  };

  empty() {
    this.containerTarget.innerHTML = "";
  }

  resultsCountValueChanged() {
    this.dispatch("results-changed", { detail: { count: this.resultsCountValue } });
  }
}
